export default () => ({
  root: {
    display: 'flex',
    height: '100%',
    flexFlow: 'column',
  },
  editorContainer: {
    height: 'calc(100% - 106px)',
    width: '100%',
  },
});
